<template>
  <div>
    <div class="ch-agr-box">
      <div class="ch-agr-title">用户信息</div>
      <div class="ch-agr-content-box">
        <div class="ch-agr-content">
          <el-form ref="form" style="display: flex;flex-wrap: wrap;justify-content: space-between;" :rules="rules"
            :model="form" class="form" label-width="140px">
            <el-form-item v-if="false" label="企业头像：" prop="avatar">
              <el-input v-model="form.avatar"></el-input>
            </el-form-item>
            <el-form-item style="width:30%;" label="营业执照：" prop="imgLicense">
              <el-upload :class="{ hide: form.imgLicense }" :action="actionUrl" list-type="picture-card"
                :data="{busiType:'BUSINESS_LICENSE'}"
                :before-upload="beforeAvatarUpload"
                :on-remove="(file, fileList) => handleRemove(file, fileList, 1)" :file-list="imgLicenseFileList"
                :headers="headersObj" :limit="1"
                :on-success="(response, file, fileList) => onSuccess(response, file, fileList, 1)">
                <i class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>

            <el-form-item style="width:30%;" label="身份证正面" prop="idCardImgFront">
              <el-upload :class="{ hide: form.idCardImgFront }" :action="actionUrl" list-type="picture-card"
                :before-upload="beforeAvatarUpload"
                :on-remove="(file, fileList) => handleRemove(file, fileList, 2)" :file-list="idCardImgFrontFileList"
                :headers="headersObj" :limit="1"
                :on-success="(response, file, fileList) => onSuccess(response, file, fileList, 2)">
                <i class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>

            <el-form-item style="width:30%;" label="身份证反面" prop="idCardImgBack">
              <el-upload :class="{ hide: form.idCardImgBack }" :action="actionUrl" list-type="picture-card"
                :before-upload="beforeAvatarUpload"
                :on-remove="(file, fileList) => handleRemove(file, fileList, 3)" :file-list="idCardImgBackFileList"
                :headers="headersObj" :limit="1"
                :on-success="(response, file, fileList) => onSuccess(response, file, fileList, 3)">
                <i class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
            <el-form-item style="width: 50%;" label="企业名称：" prop="companyName">
              <el-input v-model="form.companyName" placeholder="上传营业执照自动回显"></el-input>
            </el-form-item>
            <el-form-item style="width: 50%;" label="责任人：" prop="name">
              <el-input  v-model="form.name" placeholder="上传营业执照自动回显"></el-input>
            </el-form-item>
            <el-form-item style="width: 50%;" label="社会信用代码：" prop="creditCode">
              <el-input v-model="form.creditCode" placeholder="上传营业执照自动回显"></el-input>
            </el-form-item>
            <el-form-item style="width: 50%;" label="供应商类型" prop="supplyType">
              <el-select :disabled="supplyTypeTag"  v-model="form.supplyType" placeholder="请选择供应商类型" filterable>
                <el-option v-for="item in dictionaryList" :key="item.code" :label="item.value"  :value="item.code">
              </el-option>
              </el-select>
            </el-form-item>
          
            <el-form-item style="width: 50%;" label="手机号：" prop="phone">
              <el-input v-model="form.phone"></el-input>
            </el-form-item>
            <el-form-item v-if="false" style="width: 50%;" label="短信验证码：" prop="smsCode">
              <el-input v-model="form.smsCode"></el-input>
              <el-button style="margin-left:10px;" type="success" :disabled="VCodeDisabled" plain @click="getVCode">{{VCodeText }}</el-button>
            </el-form-item>
            <el-form-item style="width: 50%;" label="登录密码：" prop="password">
              <el-input v-model="form.password" type="password" show-password clearable maxlength="20" minlength="8"></el-input>
            </el-form-item>
            <el-form-item style="width: 50%;" label="确认密码：" prop="confirmPass">
              <el-input v-model="form.confirmPass" type="password" show-password clearable maxlength="20" minlength="8">></el-input>
            </el-form-item>
            <el-form-item style="width: 50%;" label="电子邮箱：" prop="email">
              <el-input v-model="form.email"></el-input>
            </el-form-item>
            <el-form-item  style="width: 50%;"  label="企业规模：" prop="supplierScale">
              <el-select v-model="form.supplierScale" placeholder="请选择企业规模" filterable>
                <el-option v-for="item in supplierScaleList" :key="item.code" :label="item.value"  :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item style="width: 50%;" label="业绩营收：" prop="performanceRevenue">
              <el-input :min="0" placeholder="请输入业绩营收" v-model="form.performanceRevenue">
                <template slot="append">万元</template>
              </el-input>
            </el-form-item>
            <el-form-item style="width: 50%;" label="注册资金：" prop="registeredCapital">
              <el-input :min="0" placeholder="请输入注册资金" v-model="form.registeredCapital">
                <template slot="append">万元</template>
              </el-input>
            </el-form-item>
            <el-form-item style="width: 50%;" label="资产总额：" prop="totalAssets">
              <el-input :min="0" placeholder="请输入资产总额" v-model="form.totalAssets">
                <template slot="append">万元</template>
              </el-input>
            </el-form-item>

           
            
          </el-form>
        </div>
      </div>
    </div>
    <div class="ch-agr-agree">
      <el-button type="primary" class="el-button" @click="onPrev">上一步</el-button>
      <el-button type="primary" class="el-button" @click="onComplete">完成注册</el-button>
    </div>
  </div>
</template>

<script>
import req from '@/api/config/config'
import home from "@/api/home/index"
import register from "@/api/register/register"
import announcement from "@/api/announcement/announcement"
export default {
  data() {
    var checkphone = (rule, value, callback) => {
      let phoneReg = /(^1[3|4|5|6|7|8|9]\d{9}$)|(^09\d{8}$)/;
      if (value == "") {
        callback(new Error("请输入手机号"));
      } else if (!phoneReg.test(value)) {//引入methods中封装的检查手机格式的方法
        callback(new Error("请输入正确的手机号!"));
      } else {
        callback();
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('此项不能为空'));
      } else if (value !== this.form.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    }
    return {
      
      actionUrl: req.systemIp + '/sysFileInfo/upload',
      form: {
        imgLicense: "",
        idCardImgFront: "",
        idCardImgBack: "",
        totalAssets:'',
        supplyType:'',
        companyName:'',
        name:'',
        confirmPass:'',
        creditCode:'',
        password:'',
        phone:'',

      },
      rules: {
        confirmPass: [
          { validator: validatePass2, required: true, trigger: 'blur' },
        ],
        name: [
          { required: true, message: '此项不能为空', trigger: 'blur' },
        ],
        supplyType: [
          { required: true, message: '此项不能为空', trigger: 'blur' },
        ],
        creditCode: [
          { required: true, message: '此项不能为空', trigger: 'blur' },
        ],
        password: [
          { required: true, trigger: 'blur' , message: '此项不能为空',},
          { pattern:/^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*,\.])[0-9a-zA-Z!@#$%^&*,\.]{8,20}$/, message: '密码需同时包含字母大小写、数字、特殊字符！', trigger: 'blur' },
          { min: 8, max: 20, message: '密码长度需在 8到 20 位之间', trigger: 'blur' }
        ],
        phone: [
          { required: true, validator: checkphone, trigger: 'blur' },
        ],
        companyName: [
          { required: true, message: '此项不能为空', trigger: 'blur' },
        ],
        smsCode: [
          { required: true, message: '此项不能为空', trigger: 'blur' },
        ],
        email: [
          { required: true, message: '此项不能为空', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
        ],
        supplierScale: [
          { required: true, message: '此项不能为空', trigger: 'blur' },
        ],
        performanceRevenue: [
          { required: true, message: '此项不能为空', trigger: 'blur' },
          { pattern: /^\d+(\.\d+)?$/, message: '请输入正确的数字', trigger: 'blur' }
        ],
        totalAssets:[
          { required: true, message: '此项不能为空', trigger: 'blur' },
          { pattern: /^\d+(\.\d+)?$/, message: '请输入正确的资产总额', trigger: 'blur' }
        ],
        registeredCapital: [
          { required: true, message: '此项不能为空', trigger: 'blur' },
          { pattern: /^\d+(\.\d+)?$/, message: '请输入正确的数字', trigger: 'blur' }
        ],

        imgLicense: [
          { required: true, message: '此项不能为空', trigger: 'change' },
        ],
        idCardImgFront: [
          { required: true, message: '此项不能为空', trigger: 'change' },
        ],
        idCardImgBack: [
          { required: true, message: '此项不能为空', trigger: 'change' },
        ]

      },
      VCodeText: "获取验证码",
      VCodeDisabled: false,
      imgLicenseFileList: [],
      idCardImgFrontFileList: [],
      idCardImgBackFileList: [],
      headersObj: {},
      supplierScaleList: [],
      dictionaryList:[],
      supplyTypeTag:false
    };
  },
  mounted() {
    this.ensureOrgInfo()
    this.getsupplierScale()
    this.dictionary()
  },
  methods: {
    // 直接进入注册页时，首页可能未加载组织信息，这里兜底拉取一次
    ensureOrgInfo() {
      if (JSON.parse(localStorage.getItem('orgInfo') || 'null')) return
      announcement.orgInfo({ domains: 'localhost' }).then(res => {
        if (res && res.code == 0 && res.data) {
          localStorage.setItem('orgInfo', JSON.stringify(res.data))
        }
      }).catch(() => {})
    },
    // 企业类型
    dictionary(){
      home.dictionary({code:'supplier'}).then(res=>{
        this.dictionaryList=res.data

        if(true||this.$route.query.supplyType){
          this.hanlderSupplyTypeFind()
        }
      })
    },
    hanlderSupplyTypeFind(){
      let supplyTypeFind= this.dictionaryList.find(item=>{
        return item.code==this.$route.query.supplyType
      })
      if(supplyTypeFind){
        this.supplyTypeTag=true
        this.form.supplyType=this.$route.query.supplyType
      }
    },
    handleRemove(file, fileList, index) {
      if (index == 1) {//营业执照
        this.form.imgLicense = ""
      }
      if (index == 2) {//身份证正面
        this.form.idCardImgFront = ""
      }
      if (index == 3) {//身份证反面
        this.form.idCardImgBack = ""
      }

    },
    // 获取可选择的企业规模数据
    getsupplierScale() {
      register.getEnterpriseSize().then(res => {
        this.supplierScaleList = res.data
      })
    },
    beforeAvatarUpload(file) {
      const imageType=['image/jpeg','image/jpg','image/png']
      const isJPG = file.type === 'image/jpeg';
      let uploadTag=true

      if (!imageType.includes(file.type)) {
        this.$message.error('只能上传jpeg,jpg,png格式的文件');
        uploadTag=false
      }
      return uploadTag
    },
    onSuccess(response, file, fileList, index) {
      if (index == 1) {//营业执照
        this.form.imgLicense = response.data.fileId
        if(response.data.uscc){
          this.form.companyName = response.data.name//公司名称
          this.form.name = response.data.legal//负责人
          this.form.creditCode=response.data.uscc//社会信用代码
        }else{
          this.$message.error("营业执照识别失败")
        }
        
      }
      if (index == 2) {//身份证正面
        this.form.idCardImgFront = response.data.fileId
      }
      if (index == 3) {//身份证反面
        this.form.idCardImgBack = response.data.fileId
      }
    },
    onPrev() {
      this.$emit("prev")
    },

    onComplete() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          const orgInfo = JSON.parse(localStorage.getItem('orgInfo') || 'null')
          if (!orgInfo || !orgInfo.oid) {
            this.$message.error('组织信息获取失败，请刷新页面后重新提交')
            return
          }
          this.form.oid = orgInfo.oid
          register.register(this.form).then(
            res => {
              if (res.code === 0) {
                this.$emit("complete")
              } else {
                this.$message.error(res.message || '注册失败')
              }
            }
          )
        } else {

          return false;
        }
      });


    },

    /**
 * 辅助函数：判断是否为顺子号（递增或递减）
 */
isSequentialNumber(num) {
  const ascending = '0123456789';
  const descending = '9876543210';
  
  for (let i = 0; i <= 7; i++) {
    const sub = num.substring(i, i + 4);
    if (ascending.includes(sub) || descending.includes(sub)) {
      return true;
    }
  }
  
  return false;
},
    /**
 * 国内手机号码全面校验函数
 * @param {string} phone - 待校验的手机号
 * @returns {string|null} - 校验结果，null表示通过
 */
validateChinesePhone(phone) {
  // 去除空格、横线、括号等格式化字符
  const cleanPhone = phone.replace(/[-\s()（）]/g, '');
  
  // 基础格式校验
  if (!cleanPhone) return "手机号不能为空";
  if (cleanPhone.length !== 11) return "手机号必须为11位数字";
  if (!/^\d{11}$/.test(cleanPhone)) return "手机号只能包含数字";
  
  // 开头数字校验（必须为1）
  if (cleanPhone[0] !== '1') return "手机号必须以数字1开头";
  
  // 运营商号段校验（截至2025年最新号段）
  const validPrefix = /^1(3[0-9]|4[5-9]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])/.test(cleanPhone);
  if (!validPrefix) return "不支持的手机号段";
  
  // 防伪造校验（连续相同数字、顺子等）
  if (/^(\d)\1{10}$/.test(cleanPhone)) return "手机号不能为连续相同数字";
  if (this.isSequentialNumber(cleanPhone)) return "手机号不能为顺子号";
  
  // 校验通过
  return 1;
},
    getVCode() {
      let _that = this;

      let validateTag= this.validateChinesePhone(this.form.phone)
      if(validateTag==1){//校验通过
        register.getVCode(this.form.phone).then(
          res => {
            this.VCodeDisabled = true;
            let i = 60;
            let second = setInterval(function () {
              _that.VCodeText = i + "秒以后再试";
              i--;
              if (i === 0) {
                _that.VCodeDisabled = false;
                _that.VCodeText = "获取验证码";
                clearInterval(second);
              }
            }, 1000)
          }
        )
      }else{//校验没通过
        this.$message.error(validateTag)
      }
      // if (!this.form.phone) {
      //   register.getVCode(this.form.phone).then(
      //     res => {
      //       this.VCodeDisabled = true;
      //       let i = 60;
      //       let second = setInterval(function () {
      //         _that.VCodeText = i + "秒以后再试";
      //         i--;
      //         if (i === 0) {
      //           _that.VCodeDisabled = false;
      //           _that.VCodeText = "获取验证码";
      //           clearInterval(second);
      //         }
      //       }, 1000)
      //     }
      //   )
      // } else {
      //   this.$message.warning("手机号不能为空")
      // }

    }
  }
};
</script>


<style lang="less" scoped>
.ggggggg {
  /dee/.el-upload {
    display: none !important;
  }
}

.ch-agr-box {
  margin-top: 35px;
  /* padding: 35px 30px; */
  border: 1px solid #efefef;

  >.ch-agr-title {
    font-size: 24px;
    color: #666666;
    font-weight: 400;
    text-align: center;
  }

  >.ch-agr-content-box {
    margin-top: 35px;
    padding: 31px 0;
    box-sizing: border-box;

    >.ch-agr-content {
      font-size: 14px;
      color: #666666;
      line-height: 24px;
      /* padding: 0 50px; */
      padding-left: 140px;
      padding-right: 20px;
      width: 100%;
      box-sizing: border-box;
      margin: auto;
    }

    >.ch-agr-content::-webkit-scrollbar-thumb {
      background-color: #efefef;
    }
  }

  .form {
    margin-left: -120px;

    /deep/ .el-form-item__content {
      display: flex;

      /deep/ .el-input {
        flex: 1;
      }
    }
  }
}

.ch-agr-agree {
  margin-top: 35px;
  text-align: center;

  .el-button {
    padding-left: 40px;
    padding-right: 40px;
  }
}
</style>
<style>
.hide .el-upload--picture-card {
  display: none;
}
</style>
  